import {
  UPDATE_APPROVAL_TOUR_LIST_START,
  UPDATE_APPROVAL_TOUR_LIST_SUCCESS,
  UPDATE_APPROVAL_TOUR_LIST_ERROR,
  UPDATE_APPROVAL_TOUR_LIST_CLEAR,
  UPDATE_APPROVAL_TOUR_INFO_START,
  UPDATE_APPROVAL_TOUR_INFO_SUCCESS,
  UPDATE_APPROVAL_TOUR_INFO_ERROR,
  UPDATE_APPROVAL_TOUR_SEND_START,
  UPDATE_APPROVAL_TOUR_SEND_SUCCESS,
  UPDATE_APPROVAL_TOUR_SEND_ERROR,
} from "../Constants/UpdateApprovalTourConstant";
const initialState = {
  loading: false,
  tourList: [],
  tourInfo: undefined,
  tourSend: undefined,
  updateLoading: false,
};
export default function UpdateApprovalTourReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case UPDATE_APPROVAL_TOUR_LIST_START:
      return {
        ...state,
        updateLoading: true,
      };
    case UPDATE_APPROVAL_TOUR_LIST_SUCCESS:
      return {
        ...state,
        tourList: action.payload,
        updateLoading: false,
      };
    case UPDATE_APPROVAL_TOUR_LIST_ERROR:
      return {
        ...state,
        updateLoading: false,
        message: action.error.message,
      };
    case UPDATE_APPROVAL_TOUR_LIST_CLEAR:
      return {
        ...state,
        tourList: [],
      };
    case UPDATE_APPROVAL_TOUR_INFO_START:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_APPROVAL_TOUR_INFO_SUCCESS:
      return {
        ...state,
        tourInfo: action.payload,
        loading: false,
      };
    case UPDATE_APPROVAL_TOUR_INFO_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case UPDATE_APPROVAL_TOUR_SEND_START:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_APPROVAL_TOUR_SEND_SUCCESS:
      return {
        ...state,
        tourSend: action.payload,
        loading: false,
      };
    case UPDATE_APPROVAL_TOUR_SEND_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };

    default:
      return state;
  }
}
